// @flow strict

import * as React from 'react';
import HeroHeader from '../../components/HeaderHero';
import type { BlockRichText } from '../../internal/types';

type PropTypes = {|
  highlight: string,
  title: string,
  titleImage?: string,
  subtitle: string,
  intro: BlockRichText,
  image: string,
|};

export default (props: PropTypes) => {
  return (
    <HeroHeader
      highlight={props.highlight}
      title={props.title}
      subtitle={props.subtitle}
      image={props.image}
      titleImage={props.titleImage}
    >
      {props.intro}
    </HeroHeader>
  );
};
